'use client';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import { useOnePageData } from '@/entities/page';

import styles from './contentPage.module.scss';

interface ContentPageProps {
  slug: string;
  breadcrumbs?: ReactNode;
}

const ContentPage: FC<ContentPageProps> = (props) => {
  const { slug, breadcrumbs } = props;
  const { data } = useOnePageData({ slug });

  if (!data) {
    return null;
  }

  return (
    <main className={classNames('page', styles.contentPage)}>
      <div className={classNames('container', styles.contentPage__wrapper)}>
        <div className={styles.contentPage__title_block}>
          <h1 className={styles.contentPage__title}>{data.name}</h1>
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: data.text }}
          className={styles.contentPage__content}
        ></div>
      </div>
      <div className="container">{breadcrumbs}</div>
    </main>
  );
};

export default ContentPage;
